import { apiSlice } from "../../app/api/apiSlice";

export const maxLoanWarningLogApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		maxLoanWarningLog: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/loan/max_loan_warning_override/",
				method: "POST",
				body: credentials,
			}),
		}),
	}),
});

export const { useMaxLoanWarningLogMutation } = maxLoanWarningLogApiSlice;
